export default __webpack_public_path__ + "static/media/PropertyDev_Button-01.e84860c8.png";